var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',[_vm._v("Effettua il login per visualizzare il catalogo")])])
}]

export { render, staticRenderFns }